const customFormats = {
    'lettersOnly': /^[a-zA-Z\ ]+$/,
    'phone': /^[0-9\+\-\ ]+$/,
    'numbersOnly': /^[0-9]+$/,
    'lettersAndNumbers': /^[a-zA-Z0-9\+\ ]+$/,
    'email': /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,

}
export default customFormats;
